export enum PasswordInputTypes {
  TEXT = "TEXT",
  PASSWORD = "PASSWORD",
}
